/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
  return {
    text: {
      primary: theme.darkTextPrimary,
      main: theme.darkPrimary,
      secondary: theme.darkGray,
    },
    primary: {
      main: theme.lightPrimary,
      secondary: theme.darkPrimary,
      tertiary: theme.lightSecondary,
    },
    drawer: {
      main: theme.darkBackgroundText,
      textMain: theme.darkPrimary,
      textSecondary: theme.darkGray,
      border: theme.lightGray,
    },
    toolbar: {
      main: theme.lightPrimary,
      secondary: theme.darkBackgroundText,
      unselected: theme.darkGray,
      selected: theme.darkTextPrimary,
    },
    chip: {
      main: theme.lightPrimary,
      selected: theme.darkPrimary,
      textMain: theme.darkBackgroundText,
      hover: theme.lightSecondary,
    },
    menu: {
      primary: "#000000",
      secondary: "#000000",
      selected: "transparent",
      unselected: "transparent",
    },
  };
}
